//deps
import React from "react";

// interfaces
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// components
import { PaymentGroupData, PaymentGroupMeta, CredPaymentMethod, CredPayGroup } from "@swiggy-private/payment-ui";

// hooks
import { usePaymentActions } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UsePaymentActions";
import { useCredPayHandler } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UseCredPayHandler";

interface CredPayGroupHandlerProps extends Omit<PaymentGroupHandlerProps, "paymentGroup"> {
    paymentGroup: PaymentGroupData<PaymentGroupMeta, CredPaymentMethod>;
}

export function CredPayGroupHandler(props: CredPayGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const paymentActions = usePaymentActions({ onSelect, onPay });
    const { isEligible, bannerText, isSdkAvailable, isOfferLoading } = useCredPayHandler();
    return (
        <div>
            <CredPayGroup
                paymentActions={paymentActions}
                paymentData={paymentGroup}
                bannerText={bannerText}
                isEligible={isEligible}
                isSdkAvailable={isSdkAvailable}
                isOfferLoading={isOfferLoading}
                {...otherProps}
            />
        </div>
    );
}
